import React, { Component } from 'react'
import styled from 'styled-components'
import { history } from '../../../store'

const Container = styled.div`
  border: 1px solid #CCCCCC;
  border-radius: 2px;
  background-color: #FFFFFF;
  width: 288px;
`
const ContentArea = styled.div`
  padding: 10px 16px 16px 16px;

  > button {
    display: block;
    padding: 12px 0px;
    width: 100%;
    margin: 0;
    height: 70px;
  }
`
const TitleArea = styled.div`
  height: 51px;
  margin-bottom: 24px;
`
const ImageArea = styled.div`
  float: left;
  height: 100%;
  margin-right: 15px;
  padding-right: 15px;
  border-right: 1px solid #CCCCCC;

  display: flex;
  flex-direction: column;
  justify-content: center;
`
const Content = styled.p`
  font-family: Lato-Regular;
  font-size: 14px;
  color: #2B2B2B;
  line-height: 22px;
  padding: 0;
  margin: 0;
  vertical-align: top;
  padding-top: 3px;
`

export class Action extends Component {
  onButtonClick = event => {
    if(this.props.target){
      window.open(this.props.to, this.props.target);
    } else if(this.props.onDialog) {
      this.props.onDialog()
    } else {
      history.push(this.props.to);
    }
  };

  render() {
    const btnClassNames = `secondary-button ${this.props.className}`
    const hasPopup = this.props.onDialog ? true : false;

    return (
      <Container>
        <ContentArea>
          <TitleArea>
            <ImageArea>
                <img src={this.props.imagem} alt={this.props.buttonText} />
            </ImageArea>
            <Content>{this.props.content}
            </Content>
          </TitleArea>
          <button type={'button'} role={hasPopup ? undefined : 'link'} aria-haspopup={hasPopup} onClick={this.onButtonClick} className={btnClassNames}>{this.props.buttonText}</button>
        </ContentArea>
      </Container>
    )
  }
}

export default Action;
